import { EventType, SourcePages, ImpressionType } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { SrpFilterApiParams } from 'lib/srpFilterTransformers';

function event(params?: SrpFilterApiParams): EventData {
  return {
    event_type: EventType.appEvent,
    source_page: SourcePages.Srp,
    app_event_type: EventType.searchCreate,
    impression_type: ImpressionType.srpResult,
    event_context: {
      params,
    },
  };
}

export default event;
